import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import { _LIST_SUBJECT_ELECTIVE } from "../../models/elective";
import { Card } from "react-bootstrap";
import {
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { MuiModalWindow, NoData } from "../../utils";
import ViewSubjectDetails from "./viewSubjectDetails";
import DoneOutlineOutlinedIcon from "@mui/icons-material/DoneOutlineOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";

const ElectiveCourseList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const [showView, setShowView] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState([]);

  useEffect(() => {
    if (props.dataSource.id) {
      loadData();
    }
  }, [props.dataSource]);

  const field = (fieldName) => props?.dataSource?.[fieldName] || "";

  const loadData = () => {
    setLoader(true);
    context.setLoader(true);
    _LIST_SUBJECT_ELECTIVE({ elective_id: field("id") }).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      } else {
        setDataList([]);
      }
      setLoader(false);
      context.setLoader(false);
    });
  };

  const handleClick = (item) => {
    setSelectedSubject(item);
    setShowView(true);
  };

  return (
    <>
      <div className="container-sm py-md-3">
        {(props.dataSource.selection_id ||
          props.dataSource.selection_id_same_nature) && (
          <div
            className="p-3 text-center text-uppercase fs-5 bg-green-50 mb-3"
            style={{ border: "1px dashed green" }}
          >
            <TaskAltOutlinedIcon className="me-2" />
            Selection closed
          </div>
        )}
        <Card>
          <Card.Header className="card-header-bg fw-bold text-uppercase">
            {field("elective_title")}
          </Card.Header>

          {dataList.length > 0 && (
            <>
              <Card.Body className="p-0">
                {props.dataSource.notes_to_students && (
                  <>
                    <div className="py-2 px-1 fs-6">
                      {field("notes_to_students")}
                    </div>
                    <Divider />
                  </>
                )}
                <List component="nav" aria-labelledby="nested-list-subheader">
                  {dataList.map((item, i) => {
                    return (
                      <>
                        {i !== 0 && <Divider />}
                        <ListItemButton
                          onClick={(e) => handleClick(item)}
                          className={
                            (!item.total_vacant || item.total_vacant < 1) &&
                            "bg-red-50"
                          }
                        >
                          <ListItemText
                            primary={item.subject_name}
                            secondary={item.subject_code}
                          />
                          <IconButton edge="end">
                            <ArrowForwardIosOutlinedIcon />
                          </IconButton>
                        </ListItemButton>
                      </>
                    );
                  })}
                </List>
              </Card.Body>
            </>
          )}
          {!loader && dataList.length < 1 && (
            <Card.Body>
              <NoData />
            </Card.Body>
          )}
        </Card>
      </div>

      <MuiModalWindow
        title={selectedSubject?.subject_code}
        open={showView}
        onClose={(e) => setShowView(false)}
      >
        <ViewSubjectDetails subject={selectedSubject} {...props} />
      </MuiModalWindow>
    </>
  );
};
export default ElectiveCourseList;
